module.exports = __webpack_public_path__ + "r-v3/img/device-sound_test.5c43fbd2.svg";